import React from 'react';
import '../../App.css';
import '../../bootstrap.css';
import * as TodoUtil from '../../helpers/TodoUtil';
import * as Database from '../../helpers/Database';
import { TODO, TODO_INREPLYTO } from './TODO.js';
import { getLocalDateString, DEFAULT_TIMEZONE } from '../../helpers/Util';
let _ = require('lodash');

const SUCCESS_MESSAGE_TIMER = 2000;
const ERROR_NONE = 'None';

// ========= TODO EDITOR =============

export const TODO_STATUS = { // name should match key
  NotStarted: {
    name: 'NotStarted',
    color: 'gray'
  },
  InProgress: {
    name: 'InProgress',
    color: 'green'
  },
  Paused: {
    name: 'Paused',
    color: 'crimson'
  }
}

function todoToHtmlBlock(todo) {
  return (
    <div>
      <div>importance: {todo.importance}</div>
      <div>description: {todo.description}</div>
      <div>recurrence: {todo.recurrence}</div>
      <div>createdTimestamp:{todo.createdTimestamp} ({TodoUtil.getTimestampString(todo.createdTimestamp)})</div>
      <div>updatedTimestamp:{todo.updatedTimestamp} ({TodoUtil.getTimestampString(todo.updatedTimestamp)})</div>
      <div>notes: {todo.notes}</div>
      <div>status: {todo.status}</div>
      <div>chatPath: {todo.chatPath}</div>
    </div>
  );
}

function getTimestampFromTodo(todo) {
  // Argument = a todo group in the form of
  // {
  //    <todo id>: {todoId: <string>, logId, <string>, dataEntryContent: {...}, ...}
  //    <todo id>: {...}
  // }
  return TodoUtil.getTimestampFromTodoList(todo);
}

function sortAndFilterTodosByTimestamp(todos) {
  let sortedTodos = _.sortBy(todos, t => {
    let newMsgTodos = t[1].newMessage;
    if (!_.isEmpty(newMsgTodos)) {
      let data = getTimestampFromTodo(newMsgTodos);
      t[1].timePassed = data.timePassed; // To be used by TODO.js
      return data.timestamp;
    }
  });
  return sortedTodos;
}

export class TODOEditor extends React.Component {
  constructor(props) {
    super(props);
    this.cache = {
      ClientID: this.props.userId ? this.props.userId : '',
      Todo: '',
      StartDate: getLocalDateString(new Date(), DEFAULT_TIMEZONE).replace(/-/g, "/"),
      RepeatDay: 'None',
      RepeatHour: 'na',
      RepeatMinute: 'na',
      RepeatAMPM: 'am',
      Importance: 'normal',
      status: this.props.markAsInProgress ? TODO_STATUS.InProgress.name : TODO_STATUS.NotStarted.name,
      notes: this.props.notes ? this.props.notes : ''
    }
    this.state = this.cache; // FUTURE: Figure out what actually needs to be put into state

    if (this.props.todoPath) {
      this.setStateOnReadingExistingTodoPath(this.props.todoPath); // Asynchronously sets state if path exists
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  setCacheAndState(partialStateObj) {
    for (let key in partialStateObj) {
      let val = partialStateObj[key];
      this.cache[key] = val;
    }
    this.setState(partialStateObj);
  }

  setStateOnReadingExistingTodoPath(todoPath) {
    TodoUtil.doOnGettingTodo(todoPath, (snapshot) => {
      if (snapshot.exists()) {
        let todoVal = snapshot.val();
        if (todoVal.notes != undefined) {
          this.setCacheAndState({ notes: todoVal.notes });
        }

        if (todoVal.description != undefined) {
          this.setCacheAndState({ Todo: todoVal.description })
        }

        if (todoVal.importance != undefined) {
          this.setCacheAndState({ Importance: todoVal.importance })
        }

        if (todoVal.status != undefined) {
          this.setCacheAndState({ status: todoVal.status })
        }
      }
    });
  }

  handleChange(e) {
    let property = e.target.name;

    if (property === "startDate") {
      let date = e.target.value.replace(/-/g, "/");
      this.setCacheAndState({ StartDate: date });
    }
    else if (property === "Recurrence")
      this.setCacheAndState({ RepeatDay: e.target.value });
    else if (property === "Hour") {
      this.setCacheAndState({ RepeatHour: e.target.value });
      this.setCacheAndState({ RepeatMinute: '00' });
    }
    else if (property === "Minute")
      this.setCacheAndState({ RepeatMinute: e.target.value });
    else if (property === "AM/PM")
      this.setCacheAndState({ RepeatAMPM: e.target.value });
  }

  clientIdChange(e) {
    this.setCacheAndState({ ClientID: e.target.value })
  }

  handleSubmit() {
    // check if the recurrence setting makes sense
    if (this.state.RepeatDay) {
      this.props.createNewTODO(this.cache.ClientID, this.cache.Todo, this.cache.StartDate, this.cache.RepeatDay,
        this.cache.RepeatHour, this.cache.RepeatMinute, this.cache.RepeatAMPM,
        this.cache.Importance, this.cache.notes, this.cache.status);
    }
  }

  handleCancel() {
    this.props.cancelTODO();
  }

  notesChange(e) {
    this.setCacheAndState({ notes: e.target.value });
  }

  todoChange(e) {
    this.setCacheAndState({ Todo: e.target.value });
  }

  importanceChange(e) {
    if (e.target.checked) {
      this.setCacheAndState({ Importance: 'high' });
    } else {
      this.setCacheAndState({ Importance: 'normal' });
    }
  }

  statusChange(e) {
    this.setCacheAndState({ status: e.target.value })
  }

  render() {
    let recurringEditor = this.props.disableRecurring ? (<span />) :
      (
        <div>
          <div>
            <p className="inlineBlock slightRightMargin">Start date</p>
            <input type="date" id="startDate" name="startDate" defaultValue={getLocalDateString(new Date(), DEFAULT_TIMEZONE)} onChange={this.handleChange} />
          </div>
          <div>
            <p className="inlineBlock slightRightMargin">Repeat</p>
            <select name="Recurrence" onChange={this.handleChange}>
              <option>None</option>
              <option>Daily</option>
              <option>Every Monday</option>
              <option>Every Tuesday</option>
              <option>Every Wednesday</option>
              <option>Every Thursday</option>
              <option>Every Friday</option>
              <option>Every Saturday</option>
              <option>Every Sunday</option>
            </select>
            <select name="Hour" onChange={this.handleChange}>
              <option>na</option>
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
              <option>8</option>
              <option>9</option>
              <option>10</option>
              <option>11</option>
              <option>12</option>
            </select>
            <select name="Minute" onChange={this.handleChange}>
              <option>na</option>
              <option>00</option>
              <option>30</option>
              <option>40</option>
              <option>50</option>
            </select>
            <select name="AM/PM" onChange={this.handleChange}>
              <option>am</option>
              <option>pm</option>
            </select>
          </div>
        </div>
      );

    return (
      <div className='popup'>
        <div className='popupInner p-2 row'>
          <div className="slightPaddingAllSides col">
            <div>
              <p className="inlineBlock slightRightMargin">ClientID</p>
              <input type="text" value={this.state.ClientID} onChange={this.clientIdChange.bind(this)} />
            </div>
            <div>
              <p className="inlineBlock slightRightMargin">TODO</p>
              <input type="text" name="Todo" value={this.state.Todo} onChange={this.todoChange.bind(this)} />
            </div>
            {recurringEditor}
            <div>
              <input type="checkbox" className="slightRightMargin" name="highImportance" checked={this.state.Importance === 'high'} onChange={this.importanceChange.bind(this)} />
              <label>High importance</label>
            </div>
            {
              this.props.todoPath ? (
                <button className="slightRightMargin" onClick={this.handleSubmit}>Update</button>
              ) : (
                <button className="slightRightMargin" onClick={this.handleSubmit}>Create</button>
              )
            }
            <button className="slightRightMargin" onClick={this.handleCancel}>Cancel</button>
          </div>
          <div className='col'>
            <p className="inlineBlock slightRightMargin">Notes</p>
            <textarea style={{ width: '90%', height: '75%' }} value={this.state.notes} onChange={this.notesChange.bind(this)} />
            Status: <select value={this.state.status} onChange={this.statusChange.bind(this)}>
              {
                Object.keys(TODO_STATUS).map(statusName => {
                  return (<option>{TODO_STATUS[statusName].name}</option>);
                })
              }
            </select>
          </div>
        </div>
      </div>
    );
  }
}

// ========= TODO LIST =============

export class TODOList extends React.Component {
  constructor(props) {
    super(props);
    this.newTodoItemCache = {};
    this.obj = {};
    this.userProgressCache = {};

    this.state = {
      newTodoItem: {},
      showTODOEditor: false,
      userProgress: {}
    };

    this.addNewItemSubmit = this.addNewItemSubmit.bind(this);
    this.createNestedObject = this.createNestedObject.bind(this);


  }

  componentWillReceiveProps(nextProps) {
    if (this.props.userId != nextProps.userId) {
      this.setState({ ClientID: nextProps.userId });
    }
  }

  componentWillMount() {
    Database.doOnUserProgressMod((key, val) => {
      this.userProgressCache[key] = val;
      this.setState({
        userProgress: this.userProgressCache
      })
    });
  }

  componentWillUnmount() {
    Database.clearUserProgressModCallback();
  }

  addNewItemSubmit(path) {
    // add new TODO item
    TodoUtil.addNewTodoItemWithCustomPathAndFBID(path, this.state.newTodoItem);
    this.setState({
      successMessageHtml: <div>Successfully added NEW TODO</div>
    }, () => setTimeout(() => this.setState({
      successMessageHtml: null
    }), SUCCESS_MESSAGE_TIMER));
  }

  addNewArchiveItemSubmit(path) {
    // add new TODO item
    TodoUtil.addNewTodoArchiveItem(path, this.state.newTodoItem);
    this.setState({
      successMessageHtml: <div>Successfully added NEW TODO</div>
    }, () => setTimeout(() => this.setState({
      successMessageHtml: null
    }), SUCCESS_MESSAGE_TIMER));
  }

  cancelTODOEditor() {
    // close popup
    this.setState({ showTODOEditor: false, todoToEditPath: null });
  }

  newTODOEditor(clientID, todo, startDate, repeatDay, repeatHour, repeatMinute, repeatAMPM, importance, notes, status) {
    // close popup
    let willDismissPopup = this.state.showTODOEditor;
    this.setState({ showTODOEditor: !willDismissPopup });
    if (willDismissPopup) {
      this.setState({ todoToEditPath: null });
    }

    // declare path
    let path = '';

    // Note: without this check, this method gets called on initialization 
    // of <TODOEditor /> which causes exception in database.js. Not sure
    // why it gets run during initialization aka without actual click.
    if (typeof clientID === "string") {
      // create path
      path = clientID + "/manual/";

      var translatedDay;
      switch (repeatDay) {
        case "Daily":
          translatedDay = "Daily";
          break;
        case "Every Sunday":
          translatedDay = 0;
          break;
        case "Every Monday":
          translatedDay = 1;
          break;
        case "Every Tuesday":
          translatedDay = 2;
          break;
        case "Every Wednesday":
          translatedDay = 3;
          break;
        case "Every Thursday":
          translatedDay = 4;
          break;
        case "Every Friday":
          translatedDay = 5;
          break;
        case "Every Saturday":
          translatedDay = 6;
          break;
        default:
          translatedDay = "None";
      }

      if (notes === undefined) { notes = null; }
      if (status === undefined) { status = TODO_STATUS.NotStarted.name }

      let now = Date.now();
      if (this.state.todoToEditPath) { // There already exists an associated TODO. So update, not create new.
        // Don't include the createdTimestamp. That remains unchanged.
        TodoUtil.updateTodoItem(this.state.todoToEditPath, todo, importance, notes, status, now, this.props.adminId);
        this.setState({
          successMessageHtml: <div>Successfully updated existing TODO</div>
        }, () => setTimeout(() => this.setState({
          successMessageHtml: null
        }), SUCCESS_MESSAGE_TIMER));
        this.hideTODOActionPicker();
      } else {
        // translate hour into military time
        if (repeatAMPM === "pm") {
          repeatHour = Number(repeatHour) + 12;
        }
        else if (Number(repeatHour) < 10) {
          repeatHour = "0" + repeatHour;
        }

        // create object to push into databse
        this.newTodoItemCache['importance'] = importance;
        this.newTodoItemCache['status'] = status;
        this.newTodoItemCache['description'] = todo;
        this.newTodoItemCache['recurrence'] = startDate + "-" + translatedDay + "-" + repeatHour + ":" + repeatMinute;
        this.newTodoItemCache['createdTimestamp'] = now;
        this.newTodoItemCache['updatedTimestamp'] = now;
        this.newTodoItemCache['lastAdminToEdit'] = this.props.adminId;
        this.newTodoItemCache['notes'] = notes;

        //console.log(this.newTodoItemCache);
        // set state of new TODO
        this.setState({ newTodoItem: this.newTodoItemCache }, function () {
          // console.log(path);
          // console.log(this.state.newTodoItem);

          if (repeatHour === "na")
            this.addNewItemSubmit(path);
          else {
            if (translatedDay === "None" || translatedDay === "Daily")
              path = repeatHour + "/" + repeatMinute + "/" + path;
            else
              path = "weekly/" + translatedDay + "/" + repeatHour + "/" + repeatMinute + "/" + path;

            this.addNewArchiveItemSubmit(path);
          }
        });
      }
    }
  }

  createNestedObject(path, value) {
    var schema = this.obj;  // a moving reference to internal objects within obj
    var pList = path.split('.');
    var len = pList.length;
    for (var i = 0; i < len - 1; i++) {
      var elem = pList[i];
      if (!schema[elem]) schema[elem] = {}
      schema = schema[elem];
    }

    schema[pList[len - 1]] = value;
  }

  submitLoggingForm(todoItemPath) {
    this.props.submitLoggingForm(todoItemPath);
  }

  onToggleStatus(removedItemPath) {
    // if a new message was deleted, change favicon to neutral if no new messages left
    for (let userId in this.props.todoItems) {
      let todoItemsForUser = this.props.todoItems[userId][0];
      if (todoItemsForUser) {
        for (let todoType in todoItemsForUser) {
          let todoTypeCollection = todoItemsForUser[todoType];
          for (let todoId in todoTypeCollection) {
            let removedItemSplit = removedItemPath.split('/');
            let removedTodoId = removedItemSplit[removedItemSplit.length - 1];
            if (todoId === removedTodoId) {
              continue;
            }

            let todoItem = todoTypeCollection[todoId];
            if (this.props.fullViewMode &&
              (todoType === 'newMessage' || todoItem.importance === 'high') &&
              (!todoItem.recurrence || todoItem.recurrence.includes('None-na:na'))
            ) {
              return;
            } else if (this.props.dataEntryMode) {
              if (
                (todoItem.inReplyTo === TODO_INREPLYTO.DataEntry ||
                  todoItem.inReplyTo === TODO_INREPLYTO.DataEntryManual ||
                  todoItem.inReplyTo === TODO_INREPLYTO.DataEntry) &&
                (todoType === 'newMessage' || todoItem.importance === 'high') &&
                (!todoItem.recurrence || todoItem.recurrence.includes('None-na:na'))
              ) {
                return;
              }
            } else if (
              (todoItem.inReplyTo !== TODO_INREPLYTO.DataEntry &&
                todoItem.inReplyTo !== TODO_INREPLYTO.DataEntryManual &&
                todoItem.inReplyTo !== TODO_INREPLYTO.DataEntry) &&
              (todoType === 'newMessage' || todoItem.importance === 'high') &&
              (!todoItem.recurrence || todoItem.recurrence.includes('None-na:na'))
            ) {
              return;
            }
          }
        }
      }
    }

    if (this.props.fullViewMode) {
      this.makeFaviconNormal('data');
      this.makeFaviconNormal('coach');
    } else if (this.props.dataEntryMode) {
      this.makeFaviconNormal('data');
    } else {
      this.makeFaviconNormal('coach');
    }
  }

  moveSelectedUserTodoToFront(uniqueTodos, selectedUserId) {
    if (_.isEmpty(selectedUserId) || _.isEmpty(uniqueTodos)) {
      return;
    }

    if (!_.isEmpty(uniqueTodos) && uniqueTodos[0] === selectedUserId) { // user is already at the top
      return;
    }

    for (let i in uniqueTodos) {
      let todo = uniqueTodos[i];
      if (!_.isEmpty(todo) && todo[0] === selectedUserId) {
        uniqueTodos.splice(i, 1);
        uniqueTodos.unshift(todo);
        return;
      }
    }
  }

  onEditTodo(todoPath) {
    TodoUtil.setAdminLastCheckedNotesTime(todoPath, this.props.adminId);
    this.setState({ showTODOEditor: true, todoToEditPath: todoPath });
  }

  clickTODO(e, metadata) {
    this.setState({ successMessageHtml: null });
    this.props.onClick(e, metadata);
  }

  removeSuccessMessage() {
    this.setState({ successMessageHtml: null });
  }

  makeFaviconRed = (type) => {
    Database.setFirebaseEntry(`adminTool/faviconRed/${type}`, true);
  }

  makeFaviconNormal = (type) => {
    Database.setFirebaseEntry(`adminTool/faviconRed/${type}`, false);
  }

  render() {
    var highPriPaidArray = [], highPriFreeArray = [], mediumPriPaidArray = [], mediumPriFreeArray = [],
      lowPriPaidArray = [], lowPriFreeArray = [], startDate, today = getLocalDateString(new Date(), DEFAULT_TIMEZONE).replace(/-/g, "/"), isSameRound = false;

    Object.keys(this.props.todoItems).map((todoItemId) => {
      // map todo object to different props
      let todoItem = this.props.todoItems[todoItemId];

      // grab importance and startDate values
      // create an object without TODOs starting on future/past days

      if (_.isEmpty(todoItem[0])) {
        console.error(`TODOList error: todoItem[0] is null or undefined for userId todoItemId ${todoItemId}`);
      } else {
        Object.keys(todoItem[0]).map((msgType) => {
          let FbId = todoItem[0][msgType];

          if (_.isEmpty(FbId)) { // will be null for v2 migrated users
            //console.error(`TODOList error: FbId is null or undefined for userId todoItemId ${todoItemId} and msgType ${msgType}`);
          } else {
            Object.keys(FbId).map((id) => {
              let inner = FbId[id];
              if (!inner.recurrence) {
                return;
              }

              startDate = inner.recurrence.substring(0, inner.recurrence.indexOf("-"));

              //if (moment(startDate, "YYYY-MM-DD").isSameOrBefore(today)) {
              this.createNestedObject(msgType + "." + id, FbId[id]);
              var temp = [todoItemId, this.obj];

              highPriPaidArray.push(temp);
              //}
            })
          }
        })
      }

      // reset object
      this.obj = {};
    })

    //console.log(highPriArray);
    highPriFreeArray = sortAndFilterTodosByTimestamp(highPriFreeArray);
    highPriPaidArray = sortAndFilterTodosByTimestamp(highPriPaidArray);
    mediumPriFreeArray = sortAndFilterTodosByTimestamp(mediumPriFreeArray);
    mediumPriPaidArray = sortAndFilterTodosByTimestamp(mediumPriPaidArray);
    lowPriFreeArray = sortAndFilterTodosByTimestamp(lowPriFreeArray);
    lowPriPaidArray = sortAndFilterTodosByTimestamp(lowPriPaidArray);

    let uniqueTodos = highPriFreeArray.concat(highPriPaidArray).concat(mediumPriFreeArray)
      .concat(mediumPriPaidArray).concat(lowPriFreeArray).concat(lowPriPaidArray);
    uniqueTodos = _.uniqBy(uniqueTodos, (e) => e[0]);
    TodoUtil.GLOBAL_TODO_CACHE.uniqueTodos = uniqueTodos;

    this.moveSelectedUserTodoToFront(uniqueTodos, this.props.userId);
    return (
      <div>
        {
          this.state.successMessageHtml ? (
            <div style={{ position: 'fixed', top: '0', backgroundColor: 'lightgreen', border: '.5px solid', zIndex: '1' }}>
              <input style={{ color: 'red', fontSize: '40px', backgroundColor: 'unset' }} className='btn btn-secondary p-0 pl-1 pr-1 float-right' type='submit' value='x' onClick={this.removeSuccessMessage.bind(this)} />
              <div className='p-1'>
                {this.state.successMessageHtml}
              </div>
            </div>) : (<span />)
        }
        <div className="leftRightOnSameLine">
          <p className="heavyFont noMargin">TODO</p>
          <p className="heavyFont bigText noMargin singleLineHeight clickable" onClick={this.newTODOEditor.bind(this)}>+</p>
        </div>
        {
          uniqueTodos.map((todo) => {
            return (
              <TODO key={todo[0]}
                todo={todo[1]}
                id={todo[0]}
                clickTODO={this.clickTODO.bind(this)}
                submitLoggingForm={this.submitLoggingForm.bind(this)}
                onToggleStatus={this.onToggleStatus.bind(this)}
                onEditTodo={this.onEditTodo.bind(this)}
                adminId={this.props.adminId}
                editOnlyMode={false}
                dataEntryMode={this.props.dataEntryMode}
                fullViewMode={this.props.fullViewMode}
                playNotifySoundIfCoachTodoStillRed={this.props.playNotifySoundIfCoachTodoStillRed}
                playNotifySound={this.props.playNotifySound}
                makeFaviconRed={this.makeFaviconRed}
                userProgress={this.state.userProgress[todo[0]]}
                migratedUserStatus={this.props.migratedUsers[todo[0]]}
              />
            );
          })
        }
        {
          this.state.showTODOEditor ?
            <TODOEditor
              createNewTODO={this.newTODOEditor.bind(this)}
              cancelTODO={this.cancelTODOEditor.bind(this)}
              todoPath={this.state.todoToEditPath}
              disableRecurring={this.state.todoToEditPath ? true : false} // Don't allow updating any of the recurring info b/c it's too complicated right now.
              userId={this.state.todoToEditPath ? this.state.todoToEditPath.split('/')[0] : null}
              adminId={this.props.adminId}
            />
            : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/todos/TODOList.js